// Libraries
import Immutable from 'immutable'
import accounting from 'accounting'

// Shared
import flattenObjectKeys from 'shared/utils/flattenObjectKeys'

const initialState = new Immutable.Map({})

export default (state, action) => {
  state = state || initialState

  switch (action.type) {
    case 'SETTINGS_INITIALIZED':
    case 'SETTINGS_CHANGED':
      for (const key in action.payload.settings) {
        const value = action.payload.settings[key]

        state = state.set(key, value)
      }

      return state
    case 'SESSIONS_FETCH_SUCCESS': {
      const settingsData = action.payload.response.included.find((data) => data.type === 'settings').attributes
      const flattenedSettings = flattenObjectKeys(settingsData)

      accounting.settings = {
        currency: settingsData.currency,
        number: {
          precision: 0,
          decimal: settingsData.currency.decimal,
          thousand: settingsData.currency.thousand
        }
      }

      for (const key in flattenedSettings) {
        const value = flattenedSettings[key]

        state = state.set(key, value)
      }

      return state
    }
    default:
      return state
  }
}
